import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { giveGetEligibilityBackend } from './give-get-eligibility.backend';
import { giveGetEligibilityReducer } from './give-get-eligibility.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('giveGetEligibility', giveGetEligibilityReducer),
    BackendModule.forFeature('giveGetEligibility', giveGetEligibilityBackend),
  ],
})
export class DatastoreGiveGetEligibilityModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/give-get-eligibility/give-get-eligibility.module.ts